import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ClientHeader from "../../components/Client/ClientHeader";
import Footer from "../../components/Client/Footer";
import StoreRelationRow from "../../components/Client/StoreRelationRow";
import { useAuth } from "../../context/AuthContext";
import { fetchFollowedStores, unfollowStore } from "../../api/storeService";
import "../../components/Client/clientTheme.css";
import "./StoreRelationList.css";

export default function FollowedStores() {
  const { t } = useTranslation(["followedStores", "common"]);
  const { isAuthenticated, openLoginModal } = useAuth();
  const [stores, setStores] = useState(null);
  const [error, setError] = useState(null);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(() => {
    if (!isAuthenticated) return;
    setError(null);
    fetchFollowedStores()
      .then(setStores)
      .catch(() => setError(t("loadErrorMessage")));
  }, [isAuthenticated, t]);

  useEffect(() => {
    load();
  }, [load]);

  async function handleUnfollow(storeId) {
    setBusyId(storeId);
    try {
      await unfollowStore(storeId);
      setStores((prev) => prev.filter((s) => s.storeId !== storeId));
    } catch {
      setError(t("unfollowErrorMessage"));
    } finally {
      setBusyId(null);
    }
  }

  return (
    <div className="store-relation-list-page">
      <ClientHeader />

      <div className="store-relation-list-content">
        <h1 className="store-relation-list-title">{t("pageTitle")}</h1>

        {!isAuthenticated ? (
          <div className="store-relation-list-empty">
            <p>{t("loginPrompt")}</p>
            <button type="button" className="store-relation-list-login-button" onClick={openLoginModal}>
              {t("common:logIn")}
            </button>
          </div>
        ) : error ? (
          <div className="store-relation-list-empty">
            <p>{error}</p>
            <button type="button" className="store-relation-list-login-button" onClick={load}>
              {t("common:tryAgain")}
            </button>
          </div>
        ) : stores === null ? (
          <div className="store-relation-list-empty">
            <p>{t("loadingMessage")}</p>
          </div>
        ) : stores.length === 0 ? (
          <div className="store-relation-list-empty">
            <p>{t("emptyMessage")}</p>
          </div>
        ) : (
          <div className="store-relation-list">
            {stores.map((store) => (
              <StoreRelationRow
                key={store.storeId}
                store={store}
                actionLabel={t("unfollowAction")}
                onAction={handleUnfollow}
                actionBusy={busyId === store.storeId}
              />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
